interface props {
  children: React.ReactNode;
}

const Main: React.FC<props> = ({ children }) => {
  return <main className="min-h-screen w-full z-10">{children}</main>;
};

export default Main;
